import { defineMessages } from 'react-intl';

export const discountPoliciesMessages = defineMessages({
    discountPolicies: {
        id: 'discount-policies',
        defaultMessage: 'Discount policies',
    },
    policies: {
        id: 'policies',
        defaultMessage: 'Policies',
    },
    policy: {
        id: 'policy',
        defaultMessage: 'Policy',
    },
    discounts: {
        id: 'discounts',
        defaultMessage: 'Discounts',
    },
    amount: {
        id: 'amount',
        defaultMessage: 'Amount',
    },
    percent: {
        id: 'percent',
        defaultMessage: 'Percent',
    },
    manualValidDuration: {
        id: 'manual-valid-duration',
        defaultMessage: 'Manual valid duration',
    },
    maxApplicants: {
        id: 'max-applicants',
        defaultMessage: 'Max applicants',
    },
    maxApplications: {
        id: 'max-applications',
        defaultMessage: 'Max applications',
    },
    maxApplicationsPerCustomer: {
        id: 'max-applications-per-customer',
        defaultMessage: 'Max applications per customer',
    },
    year: {
        id: 'year',
        defaultMessage: 'Year',
    },
    month: {
        id: 'month',
        defaultMessage: 'Month',
    },
    week: {
        id: 'week',
        defaultMessage: 'Week',
    },
    day: {
        id: 'day',
        defaultMessage: 'Day',
    },
    count: {
        id: 'count',
        defaultMessage: 'Count',
    },
    duration: {
        id: 'duration',
        defaultMessage: 'Duration',
    },
    validDuration: {
        id: 'validDuration',
        defaultMessage: 'Valid duration in days',
    },
    createDiscountPolicySuccess: {
        id: 'create-discount-policy-success',
        defaultMessage: 'Discount policy created',
    },
    createDiscountPolicySuccessDescription: {
        id: 'create-discount-policy-success-description',
        defaultMessage: 'The discount policy has been successfully created.',
    },
    addDiscountPolicySubtitle: {
        id: 'add-discount-policy-subtitle',
        defaultMessage: 'Create a new discount policy',
    },
    deleteDiscountPolicy: {
        id: 'delete-discount-policy',
        defaultMessage: 'Delete discount policy',
    },
    deleteDiscountPolicySuccess: {
        id: 'delete-discount-policy-success',
        defaultMessage: 'Discount policy deleted',
    },
    deleteDiscountPolicySuccessDescription: {
        id: 'delete-discount-policy-success-description',
        defaultMessage: 'The discount policy has been successfully deleted.',
    },
    confirmDeleteDiscountPolicy: {
        id: 'confirm-delete-discount-policy',
        defaultMessage: 'Are you sure you want to delete this discount policy? This action cannot be undone.',
    },
    deleteDiscountPolicySubtitle: {
        id: 'delete-discount-policy-subtitle',
        defaultMessage: 'Permanently delete discount policy {name}',
    },
    backToAllDiscountPolicies: {
        id: 'back-to-all-discount-policies',
        defaultMessage: 'Back to all discount policies',
    },
    discountPolicyDashboard: {
        id: 'discount-policy-dashboard',
        defaultMessage: 'Discount policy dashboard',
    },
    editDiscountPolicySubtitle: {
        id: 'edit-discount-policy-subtitle',
        defaultMessage: 'Edit discount policy',
    },
    updateDiscountPolicySuccess: {
        id: 'update-discount-policy-success',
        defaultMessage: 'Discount policy updated',
    },
    updateDiscountPolicySuccessDescription: {
        id: 'update-discount-policy-success-description',
        defaultMessage: 'The discount policy has been successfully updated.',
    },
    discountPolicy: {
        id: 'discount-policy',
        defaultMessage: 'Discount policy',
    },
    searchDiscountPolicy: {
        id: 'search-discount-policy',
        defaultMessage: 'Search discount policy',
    },
    noDiscountPolicy: {
        id: 'no-discount-policy',
        defaultMessage: 'No discount policy',
    },
    noDiscountPolicyFound: {
        id: 'no-discount-policy-found',
        defaultMessage: 'No discount policy found',
    },
});
